import React from 'react';
import FeaturedProjects from './Home/FeaturedProjects';
import IntroSection from './Home/IntroSection';
import HeroSection from './Home/HeroSection';

function Home() {

  return (
    <>
      {/* Hero Section */}
      <HeroSection />

      {/* Intro Section */}
      <IntroSection />

      {/* Featured Projects Section */}
      <FeaturedProjects />
    </>
  );
}

export default Home;